export const options: { [key: string]: string } = {
    CREATE_COMPONENT: 'Create a component',
    MODIFY_COMPONENT: 'Modify/fix a component',
    CREATE_PAGE: 'Create a page/screen',
    MODIFY_PAGE: 'Modify/fix a page/screen',
    MODIFY_DESIGN: 'Change to match design',
    CREATE_ANIMATION: 'Creating an animation',
    CREATE_EVENT: 'Write events to Mixpanel/monitoring',
    CREATE_DATA_MODEL: 'Create/modify a data model',
    CREATE_ENDPOINT: 'Create/Modify an endpoint',
    CREATE_DJANGO_VIEW: 'Create a django view',
    MODIFY_DJANGO_VIEW: 'Modify/Fix a django view',
    CREATE_ALGORITHM: 'Write an algorithm / business logic',
    CREATE_SCRAPER: 'Scraping',
    CREATE_API_CONNECTOR:
    'Connect a screen/component to an API/view/functionality',
    REFACTOR_CODE: 'Refactor existing code',
    CREATE_TEST_CASE: 'Write test cases',
    CREATE_AUTH: 'Authorization/Authentication',
    OTHER: 'Other',
    UNCERTAIN: 'Uncertain'
};
